<template>
	<div class="section group fullWidth">
		<div class="col span_1_of_2">
			<div class="product-category-page">
				<br/>
				<router-link :to="'/' + 'products/' + $i18n.locale">
					<div class="close"></div>
				</router-link>
				<div class="catDetails">
				<!-- <quick-edit 
					type="text"
					maxlength=30  
					:emptyText="$t('prodCatReq')"
					:placeholderValue="$t('productName')" 
					:buttonOkText="'✔'"
					input
					@input="changeCategoryDetails('name')"
					:buttonCancelText="'X'"
					:classes="vueQuickEditClassesTitleName" 
					v-model="productCategory.name">
				</quick-edit> -->
					<br />
					<h3><span class="field-value active" v-show="!showField('name')" @click="focusField('name')">{{productCategory.name}}</span>
					<input 
					v-show="showField('name')"
					class="field-value form-control inactive"
					v-model="productCategory.name" 
					type="text" 
					maxlength=30
					@focus="focusField('name')" 
					@blur="$v.productCategory.name.$touch(); blurField('name')"
					/></h3>
					<template v-if="$v.productCategory.name.$error">
						<div v-if="!$v.productCategory.name.required" class="errorMessage2">{{ $t('productNameReq') }}</div>
					</template>
					<!-- <template v-if="$v.productCategory.name.$invalid">
						<div v-if="!$v.productCategory.name.maxLength" class="errorMessage1">
						{{ $t('prodCatLength') }}
						</div>
					</template> -->

					<div class="tagline">{{ $t('tagline') }}</div>
					<!-- <quick-edit 
					type="textarea"
					maxlength=50 
					:emptyText="$t('taglineReq')"
					:placeholderValue="$t('prodDesc')" 
					:buttonOkText="'✔'"
					input
					@input="changeCategoryDetails('hero_tagline')"
					:buttonCancelText="'X'"
					:classes="vueQuickEditClassesTextArea" 
					v-model="productCategory.hero_tagline">
					</quick-edit> -->
					<span class="field-value active" v-show="!showField('hero_tagline')" @click="focusField('hero_tagline')">{{productCategory.hero_tagline}}</span>
					<input
					v-show="showField('hero_tagline')"
					class="field-value form-control inactive"
					type="text"
					maxlength=40
					v-model="productCategory.hero_tagline"
					:state="productCategory.hero_tagline.length <= 40"
					@focus="focusField('hero_tagline')" 
					@blur="$v.productCategory.hero_tagline.$touch(); blurField('hero_tagline')"
					/>
					<template v-if="$v.productCategory.hero_tagline.$error">
						<div v-if="!$v.productCategory.hero_tagline.required" class="errorMessage">{{ $t('taglineReq') }}</div>
					</template> 
					<!-- <template v-if="$v.productCategory.hero_tagline.$invalid">
						<div v-if="!$v.productCategory.hero_tagline.maxLength" class="errorMessage1">{{ $t('taglineMaxLength') }}</div>
					</template>  -->

					<br/> 
					<br/> 
					<div class="tagline">{{ $t('taxRate') }}</div>
					<span class="field-value active">{{productCategory.tax_rate}}</span>
					<br/> 
					<br/>
					{{ $t('type') }}:
					<div style="margin-bottom: 10px; margin-top: 5px;">
						<input type="radio" v-model="productCategory.type" value="alcoholic" name="type" :disabled="!isEditing"><span style="margin-left: 5px;">{{ $t('alcoholic') }}</span> 
					</div>
					<div>
						<input type="radio" v-model="productCategory.type" value="non-alcoholic" name="type" :disabled="!isEditing" checked><span style="margin-left: 5px;">{{ $t('nonAlcoholic') }}</span> 
					</div>
					<br />
					<div 
						class="changeType-btn" 
						@click="isEditing = !isEditing; isActive = !isActive">
						<font-awesome-icon class="icon" icon="edit" />
						<span> {{ $t('changeType') }} </span>
					</div>
					<div class="save-btn-box">
						<button :disabled="$v.$invalid" class="save-btn" v-if="isEditing" @click="changeCategoryDetails">
						<span> {{ $t('save') }} </span>
						</button>
					</div>
				</div>
				<p class="editInstructions">{{ $t('editInstructions') }}</p>
			</div>
		</div>

		<div class="col span_1_of_2">
			<!-- <figure class="about-img3">
				<img class="uploadExample" src="../assets/static/images/uploadExamples/coverImage_example.jpg" />            
			</figure> -->
			<CoverImageUpload :isProductFlowEnabled="true" :prodCatId="productCategory.id" :imageUrl="productCategory.img_path"></CoverImageUpload>
			<br/>
			<div class="delete-btn" @click="deleteProductCategory"><font-awesome-icon class="icon" icon="trash" /><span>  {{ $t('removeProdCat') }}</span></div>
			<br/>
			<router-link
				class="mobileOnly"
				:to="'/' + 'products/' + $i18n.locale"
				>
				<div class="delete-btn"><font-awesome-icon class="icon" icon="chevron-left" /><span>  {{ $t('backToCatalogue') }}</span></div>
			</router-link>	
		</div>
		<ConfirmDialog :visible="showConfirmation" class="customClass"></ConfirmDialog>
		<!-- <br/>
		<hr/>
		<br />
		<h3>Products in this category</h3>
		<ProductCard
		v-for="product in product.products"
		:key="product.id"
		:product="product"
		class="card-columns"
		/> -->
		<!--FILTERING BY CATEGORIES NOT WORKING!!!-->
	</div>
</template>

<script>
import CoverImageUpload from '../components/ui/CoverImageUpload.vue'
import ConfirmDialog from 'primevue/confirmdialog';
import { mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    CoverImageUpload,
	ConfirmDialog
  },
  metaInfo() {
    return {
      title: this.title
    }
  },
  data() {
    return {
      title: 'Product Category',
      id: this.productCategory.id,
      isEditing: false,
      isActive: false,
	  showConfirmation: false,
      vueQuickEditClassesTitleName: {
        wrapper: 'form-group titleName form-inline',
        input: 'formControl input-sm',
        buttons: 'btn-group btn-group-sm',
        buttonOk: 'btn saveBtn',
        buttonCancel: 'btn closeBtn',
      },
      vueQuickEditClassesTextArea: {
        wrapper: 'form-group form-inline textBoxArea',
        input: 'formControl addInfoArea input-sm',
        buttons: 'btn-group btn-group-sm',
        buttonOk: 'btn saveBtn',
        buttonCancel: 'btn closeBtn',
      },
      editField : ''
    }
  },
  mounted() {
    this.title = this.productCategory.name
  },
  validations: {
      productCategory: {
        name: { required },       
        hero_tagline: { required },
      }
  },
  methods: {
    focusField(name){
      this.editField = name;
    },
    blurField(name){
      this.editField = '';
      this.changeCategoryDetails(name)
    },
    showField(name){
      return (this.productCategory[name] == '' || this.editField == name)
    },
    // deleteProductCategory() {
    //   if (confirm('are you sure?')) {
    //     this.$store
    //       .dispatch('productCategory/removeProductCategory', this.id)
    //       .then(() => {
    //         this.$router.push({
    //           path: '/products/en'
    //         })
    //       })
    //       .catch(e => console.log(e))
    //   }
    // },
	deleteProductCategory() {
		this.$confirm.require({
                message: this.$t('confirmProductCategoryDelete'),
                header: this.$t('areYouSure'),
                icon: 'pi pi-exclamation-triangle',
				acceptLabel: this.$t('yes'),
				rejectLabel: this.$t('no'),
				acceptIcon: 'pi pi-check',
        		rejectIcon: 'pi pi-times',
                accept: () => {
					this.$store
					.dispatch('productCategory/removeProductCategory', this.id)
					.then(() => {
						this.$router.push({
						path: '/products/en'
						})
					})
                },
                reject: () => {
					this.showConfirmation = false;
                }
        });
	},
    changeCategoryDetails(propertyName) {
      if (this.productCategory[propertyName] === "") {
        return
      }
      // if (
      //   confirm('are you sure? This will rewrite excisting category details')
      // ) 
      {
        this.$store.dispatch('productCategory/editProductCategory', this.productCategory)
        this.isEditing = !this.isEditing
        this.isActive = !this.isActive
      }
    }
  },
  created() {
    this.$store.dispatch('product/fetchProducts')
  },
  computed: mapState(['product', 'client']),

  props: {
    productCategory: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>

/*  SECTIONS  */

.fullWidth {
	width: 100%;
}
.section {
  clear: both;
  padding: 0px;
  margin: 0px;
}

/*  COLUMN SETUP  */
.col {
  display: block;
  float: left;
  margin: 1% 0 1% 2%;
}
.col:first-child {
  margin-left: 0;
}

/*  GROUPING  */
.group:before,
.group:after {
  content: '';
  display: table;
}
.group:after {
  clear: both;
}
.group {
  zoom: 1; /* For IE 6/7 */
}

/*  GRID OF TWO  */
.span_2_of_2 {
  width: 100%;
}
.span_1_of_2 {
  width: 49%;
}


.prodCatName {
    text-align: center;
    padding-left: 50px;
    font-size: 3em;
    font-weight: 600;
    width: 60%;
}

.catDetails {
    width: 90%;
    margin: auto;
    text-align: left;
    background: var(--grey-light);
    border-radius: 15px;
}

.editInstructions {
color: var(--grey);
font-size: 0.8em;
text-align: left;
margin-left: 50px;
} 

.uploadDetails {
  font-size: 1.5em;
}

button:disabled,
button[disabled]{
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}

.close {
	position: absolute;
	right: 70px;
	top: 55px;
	width: 25px;
	height: 25px;
	opacity: 0.3;
}
.close:hover {
  opacity: 1;
}
.close:before,
.close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}
.card-body {
  color: #454655;
}


.about-img3 {
  display: inline-block;
  width: 100%;
  max-width: 400px;
  text-align: center;
  vertical-align: top;
}

.errorMessage {
  margin-top: -15px;
  margin-bottom: 0.2em;
  padding-left: 5px;
  padding-top: 4px;
  color: var(--primaryDark);
  font-size: 0.58em;
  z-index: -1;
  text-align: left;
}
.errorMessage1 {
  margin-bottom: 0.2em;
  color: var(--primaryDark);
  font-size: 0.68em;
  text-align: left;
}
.errorMessage2 {
  margin-top: -22px;
  margin-bottom: 0.2em;
  padding-left: 5px;
  padding-top: 4px;
  color: var(--primaryDark);
  font-size: 0.58em;
  z-index: -1;
  text-align: left;
}

.save-btn {
    background: var(--primaryDark);
    color: var(--bright);
    padding: 0.4em;
    margin: auto !important;
    letter-spacing: 3px;
    border: none;
    border-radius: 3.5px;
    height: 38px;
    text-align: center;
    width: 5em;
}


.trash-btn {
  background: var(--bg-light);
  color: var(--bright) !important;
  padding: 5px;
  letter-spacing: 3px;
  border: none !important;
  border-radius: 3.5px;
  margin: auto;
  width: 25em;
  height: 32px;
}

.delete-btn {
  background: var(--primaryDark);
  color: var(--bright) !important;
  padding: 0.6em;
  letter-spacing: 3px;
  border: none !important;
  border-radius: 3.5px;
  margin: auto !important;
  width: 250px  !important;
  height: 40px;
  cursor: pointer;
}

.delete-btn:active {
	text-decoration:none !important;
}
.delete-btn:hover {
	text-decoration:none !important;
}

.save-btn-box {
  margin-top: 10px; 
}

.uploadExample {
  max-width: 300px;
  width: 100%;
}

textarea {
  padding: 10px;
  width: 500px;
  height: 50px;
}

@media screen and (max-width: 450px){
  .span_1_of_2 {
    width: 100%;
    padding: 0;
  }
  .span_2_of_2 {
    width: 100%;
  }
  .col {
    margin: 1% 0 1% 0%;
  }
textarea {
    width: 90%;
    height: 70px;
  }
.uploadDetails {
  font-size: 1.2em;
}

.prodCatName {
  font-size: 2em;
  width: 100%;
  margin-left: 0px;
  padding: 0px;
}
.product-category-page div {
  text-align: left;
}
.tagline {
  text-align: left;
  margin-left: 10px;
}
.catDetails {
    width: 90%;
    padding: 10px;
	margin-top: 15px;
}
.trash-btn {
    width: auto;
    margin: 0 50px;
}
.delete-btn {
    width: auto;
    margin: 40px 50px;
}
.close {
	right: 40px;
}
.editInstructions {
margin-left: 30px;
} 
}

.changeType-btn {
  background: var(--bg-light);
  color: var(--bright);
  padding: 0.6em;
  // margin: auto !important;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 200px;
  height: 40px;
  cursor: pointer;
  text-align: center;
}

.icon {
  font-size: 1.3em;
  padding: 1px;
}
.active {
    border-radius: 3.5px;
    background: none !important;
    font-weight: 600;
    font-style: normal !important;
}
.inactive {
  background-color: var(--primarySuperLight);
  border-radius: 3.5px;
  font-style: italic;
}
.trashIcon {
  color: red;
  border: red 2px solid;
  padding: 3px;
}

@media screen and (min-width: 800px){
  .catDetails {
    padding: 50px;
  }
}

@media screen and (orientation:landscape)
and (min-device-width: 319px) 
and (max-device-width: 680px) {
  .span_1_of_2 {
    width: 100% !important;
  }
}
@media screen and (min-width: 560px) {
  .mobileOnly {
    display: none;
  }
}
</style>
